import { API } from 'utils/Helper';

export const getDepositBonus = async () => {
  const response = await fetch(`${API}/admin/getDepositBonus`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getManualDeposits = async ({ uid }) => {
  const url = new URL(`${API}/api/manual-deposit-all`);
  url.searchParams.append("uid", uid);
  url.searchParams.append("req_type", "deposit");
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getPromotionsBanner = async (type = 'promotions') => {
  const response = await fetch(`${API}/website-banners?type=${type}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const data = await response.json();
  return data?.data || [];
};

export const getCampaigns = async (showOn) => {
  const response = await fetch(`${API}/api/campaigns?show_on=${showOn}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const data = await response.json();
  return data?.campaigns || [];
};
